import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'state/store';

export const getRoot = (state: RootState) => state.modal;

export const getIsOpened = createSelector(
  [getRoot],
  ({ isOpened }) => isOpened,
);

export const getModalData = createSelector([getRoot], ({ data }) => data);
